import { briefingItems } from "@/mocks/home";
import SectionHeading from "@/pages/home/components/SectionHeading";

export default function BriefingFeed() {
  const latest = briefingItems[0];

  return (
    <section className="border-b border-background-200 bg-background-100 scroll-mt-32">
      <div className="px-4 md:px-6 py-8 md:py-12">
        <SectionHeading
          id="briefing"
          index="02"
          title="实时快讯"
          subtitle="短讯并行更新，按时间密集排列，越靠上越新"
          actionText="查看全部快讯"
        />

        <div className="mt-5 grid grid-cols-1 lg:grid-cols-12 gap-5 lg:gap-8">
          <div className="lg:col-span-8">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-8">
              {briefingItems.map((item) => (
                <a
                  key={`${item.time}-${item.text}`}
                  href="#briefing"
                  className="group flex items-start gap-3 border-b border-background-200 py-3 cursor-pointer"
                >
                  <span className="w-12 shrink-0 pt-0.5 font-heading text-xs font-bold text-foreground-500 tabular-nums">
                    {item.time}
                  </span>
                  <span className="min-w-0 flex-1">
                    <span className="block text-sm leading-snug text-foreground-800 transition-colors group-hover:text-primary-600 hlwp-clamp-2">
                      {item.text}
                    </span>
                  </span>
                  <span className="shrink-0 rounded-md bg-secondary-100 px-2 py-0.5 text-xs text-secondary-900">
                    {item.tag}
                  </span>
                </a>
              ))}
            </div>
          </div>

          <aside className="lg:col-span-4">
            <div className="rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
              <span className="flex items-center gap-1.5 text-xs text-primary-600">
                <span className="w-1.5 h-1.5 rounded-full bg-primary-500 animate-pulse"></span>
                最新一条
              </span>
              <p className="mt-3 font-heading text-lg font-bold leading-snug text-foreground-900">
                {latest.text}
              </p>
              <div className="mt-4 flex items-center gap-3 text-xs text-foreground-500">
                <span className="flex items-center gap-1">
                  <i className="ri-time-line"></i>
                  {latest.time}
                </span>
                <span className="rounded-full bg-primary-100 px-2 py-0.5 text-primary-900">
                  {latest.tag}
                </span>
              </div>
              <div className="mt-5 grid grid-cols-3 gap-3 border-t border-background-200 pt-4">
                <div>
                  <p className="font-heading text-xl font-bold text-foreground-900">12</p>
                  <p className="mt-0.5 text-xs text-foreground-500">今日条数</p>
                </div>
                <div>
                  <p className="font-heading text-xl font-bold text-foreground-900">08:51</p>
                  <p className="mt-0.5 text-xs text-foreground-500">今日首条</p>
                </div>
                <div>
                  <p className="font-heading text-xl font-bold text-primary-600">3 分钟</p>
                  <p className="mt-0.5 text-xs text-foreground-500">更新间隔</p>
                </div>
              </div>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}